import moment from "moment";
import common from "../plugins/common";
import { Message, Loading } from "element-ui";
import { isEmptyObject } from "../utils/judge";

/**
 * @description 获取出行人的最低职级，所有人职级、ids, 外来人转预订人差标
 *
 * @returns {cxrList: 外来人转换为预订人id; empIds: 所有人的empId数组;allRank: 传入出行人的所有职级;minEmpRank: 传入出行人的最低职级；minEmpName：传入出行人的最低职级员工名称；}
 * */
export function getHotelEmpRank(cxrs) {
  let cxrList = common.deepCopy(cxrs);
  let minEmpRank = 99999;
  let minEmpName = "";
  let allRank = [];
  let empIds = [];
  let repeat = {};
  const userInfo = common.getUserInfo();
  let empInfo = userInfo.empInfo;

  cxrList = cxrList.map((item) => {
    if (item.empRank == void 0) item.empRank = 0;
    if (item.cxrType != 2 && item.cxrType != 3) {
      empIds.push(item.empId);
      allRank.indexOf(item.empRank) == -1 && allRank.push(item.empRank);
      if (item.empRank < minEmpRank) {
        minEmpRank = item.empRank;
        minEmpName = item.empName;
      }
    } else {
      // 2023-10-30 bug号：11372 陈伟说 外来人使用预订人差标 传入预订人的id
      empIds.push(empInfo.empId);
      repeat[item.empId] = true;
      allRank.indexOf(empInfo.empRank) == -1 && allRank.push(empInfo.empRank);
      if (empInfo.empRank < minEmpRank) {
        minEmpRank = empInfo.empRank;
        minEmpName = item.empName;
      }
    }
    return item;
  });

  return {
    minEmpRank,
    minEmpName,
    allRank,
    empIds,
    cxrList,
  };
}

/**
 * @description 国际酒店房间人员分配，获取价格计划接口的参数
 * @param [rooms] 传入的房间 有此参数代表不需要去分配房间 且传入的maxFjs、isTz无效
 * @returns {allRank: 所有人的职级；minRank：最低职级；travelerIds：出行人的empIds； roomEmpMap：已分配好的房间}
 * */
export function handleIntHotelRoom({
  preCxrList,
  maxFjs = 10, // 最大房间数
  maxNums = 1, // 每间最大人数
  rooms,
}) {
  let planSearch = {
    rooms: [],
    roomNum: 0,
    travelerIds: [],
    cxrList: [],
    minEmpName: "",
  };
  if (preCxrList && preCxrList.length > 0) {
    let cxrList = preCxrList.map((item) => {
      return {
        ...item,
      };
    });
    // 出现出行人
    const empMap = getHotelEmpRank(cxrList);
    cxrList = empMap.cxrList;
    // 分配房间
    let rs = [];
    if (rooms && rooms.length > 0) {
      rs = rooms;
    } else {
      rs = separateIntRoomGroup(cxrList, maxFjs, maxNums).rooms;
    }

    if (empMap.minEmpRank != 99999) {
      planSearch.minEmpRank = empMap.minEmpRank;
      planSearch.allRank = empMap.allRank.join(",");
    }
    // planSearch.roomEmpMap = roomEmpMap;
    planSearch.rooms = rs || [];
    planSearch.roomNum = rs.length || 0;
    planSearch.travelerIds = empMap.empIds || [];
    planSearch.minEmpName = empMap.minEmpName;
    planSearch.cxrList = cxrList;
  }
  // console.log("国际 handleIntHotelRoom === ", planSearch);
  return planSearch;
}

/**
 * @description 分配房间
 * @param {Array} empList
 * @param {Number} maxFjs 最大房间数
 * @param {Number} maxNums 单间房最大人数
 */
export function separateIntRoomGroup(empList, maxFjs = 10, maxNums = 1) {
  if (!empList || empList.length == 0) {
    return {
      rooms: [],
      isFull: false,
    };
  }
  //按性别分组
  const males = empList.filter((emp) => emp.sex == "M");
  const females = empList.filter((emp) => emp.sex != "M");

  // 男性优先，再女性
  const sortedEmployees = [...males, ...females];

  // 计算实际使用的房间数
  const totalEmployees = sortedEmployees.length;
  const neededRooms = Math.ceil(totalEmployees / maxNums);
  const actualRooms = Math.min(neededRooms, maxFjs);

  const rooms = [];
  let allRoomsFull = true; // 假设所有房间都满员

  // 分配员工到房间
  for (let i = 0; i < actualRooms; i++) {
    const start = i * maxNums;
    const end = start + maxNums;
    const roomEmployees = sortedEmployees.slice(start, end);
    rooms.push(roomEmployees);
    // 如果当前房间不满员，则整体 isFull 为 false
    if (roomEmployees.length < maxNums) {
      allRoomsFull = false;
    }
  }

  // 如果实际使用的房间数小于 maxFjs，也视为不满员（有空房间）
  if (actualRooms < maxFjs) {
    allRoomsFull = false;
  }

  return {
    rooms: rooms,
    isFull: allRoomsFull,
  };
}

// 评分描述
export function getScoreDesc(score) {
  if (!score) return "";
  if (score > 4.7) return "超棒";
  if (score > 4.5) return "很好";
  if (score >= 4) return "好";
  return "一般";
}

// 装修年限
export function establishmentDateStr(date) {
  if (!date) return "";
  try {
    let day = moment(date, "YYYY-MM-DD").format("YYYY");
    return `${day}年装修`;
  } catch (e) {
    return "";
  }
}

/**
 * @description 早餐转换
 */
export const getFreeMealStr = (freeMeal) => {
  if (freeMeal == 1) {
    return "1份早";
  }
  if (freeMeal == 2) return "2份早";
  if (freeMeal > 2) return "多份早";
  return "不含早";
};

// 校验英文名是否合法
export function validateEnglishName(name) {
  if (!name) return false;
  // 允许字母、空格、斜杠
  // 不限制斜杠和空格的组合位置
  const regex = /^[A-Za-z\s\/]+$/;
  // 额外检查：不能全是空格或斜杠
  if (!regex.test(name)) return false;
  // 确保至少有一个字母
  return /[A-Za-z]/.test(name);
}

const StarObj = {
  jj: {
    title: "经济型",
    backgroundColor: "#f2f8fd",
    color: "#1b8cff",
  },
  ss: {
    title: "舒适型",
    backgroundColor: "#dcd1ff",
    color: "#684ac5",
  },
  gd: {
    title: "高档型",
    backgroundColor: "#fef3e4",
    color: "#855419",
  },
  hh: {
    title: "豪华型",
    backgroundColor: "linear-gradient(270deg, #fea377 0%, #f5dec6 100%)",
    color: "#280a00",
  },
};

//星级名称
export const getStarRateObj = (starRate) => {
  if (starRate) {
    // 高档型
    if (starRate == "1A") return StarObj.jj;
    if (starRate == "2A") return StarObj.jj;
    if (starRate == "3A") return StarObj.ss;
    if (starRate == "4A") return StarObj.gd;
    if (starRate == "5A") return StarObj.gd;
    var star = parseInt(starRate);
    return star > 4
      ? StarObj.hh // 豪华型
      : star > 3
      ? StarObj.gd // 高档型
      : star > 2
      ? StarObj.ss // 舒适型
      : StarObj.jj; // 经济型
  }
  // 经济型
  return StarObj.jj;
};

//星级名称
export const getStarRateName = (starRate) => {
  if (starRate) {
    // 高档型
    if (starRate == "1A") return "经济型";
    if (starRate == "2A") return "经济型";
    if (starRate == "3A") return "舒适型";
    if (starRate == "4A") return "高档型";
    if (starRate == "5A") return "高档型";
    var star = parseInt(starRate);
    return star > 4
      ? "豪华型" // 豪华型
      : star > 3
      ? "高档型" // 高档型
      : star > 2
      ? "舒适型" // 舒适型
      : "经济型"; // 经济型
  }
  // 经济型
  return "经济型";
};

/**
 * @description 国际酒店续住
 * */
export async function intHtBeforeAgainOrder(
  orderItem,
  isDetail = false,
  target
) {
  const loading = Loading.service({
    target: "aol-main",
    lock: true,
    text: "请稍后...",
    spinner: "el-icon-loading",
    // background: 'rgba(0, 0, 0, 0.7)'
  });

  try {
    let minEmp;
    // 先获取订单详情
    let hotelOrderData = orderItem;
    if (!isDetail) {
      const { data: htOrderDetail } = await target.$conn.getConn(
        "hotelOrder.hotelOrderDetail"
      )({ orderId: orderItem.id });
      hotelOrderData = htOrderDetail;
    }

    // 因公-验证有房

    // 当前日期
    let nowDay = common.getDateMing(new Date(), 0);
    let now = hotelOrderData.ldrq >= nowDay ? hotelOrderData.ldrq : nowDay;
    let next = common.getDateMing(now, 1);

    // 出差申请单模式
    let bookStyle = common.getBookStyle(target.$store, 10903);
    if (
      hotelOrderData.tripType == 1 &&
      bookStyle == 2 &&
      hotelOrderData.ccsqdId
    ) {
      // 获取申请单数据
      const { data: ccsqdInfo } = await target.$conn.getConn(
        "travelRequest.travelRequestInfo"
      )({ ccsqdId: hotelOrderData.ccsqdId });
      // canBook 0不可预订 1可预订 ,
      if (ccsqdInfo && ccsqdInfo.canBook == 0) {
        let reasonMap = {
          0: "草稿",
          1: "审批中",
          2: "审批通过",
          3: "审批拒绝",
          4: "已删除",
          5: "报销中",
          6: "已报销",
        };
        let ccsqdStatusTip = reasonMap[ccsqdInfo.status];
        target.$alert(
          `当前订单关联的出差申请单[${ccsqdInfo.ccsqdNo}]不可预订;申请单状态:${
            ccsqdStatusTip || ""
          }`,
          "温馨提示",
          {
            type: "error",
          }
        );
        loading.close();
        return;
      }
      // 根据routeId获取行程
      if (ccsqdInfo.allRouteList && ccsqdInfo.allRouteList.length > 0) {
        let allRouteList = [];
        ccsqdInfo.allRouteList.forEach((routers) => {
          allRouteList = allRouteList.concat(routers);
        });
        let route = allRouteList.find(
          (s) => s.routeId == hotelOrderData.routeId
        );
        if (!route) {
          target.$alert("行程信息错误！", "", {
            type: "error",
          });
          loading.close();
          return;
        }
        let book = now >= route.routeStart && next <= route.routeEnd;
        if (!book) {
          let alertStr = "";
          if (!route.routeStart || !route.routeEnd) {
            alertStr = "行程变更，不能预订";
          } else {
            alertStr =
              "预定日期不在出差单期限内,无法预订！可预订日期范围为：" +
              (route.routeStart || "无") +
              "-" +
              (route.routeEnd || "无");
          }
          target.$alert(alertStr, "", {
            type: "error",
          });
          loading.close();
          return;
        }

        let obj = {
          cxrList: [], // 出行人列表
          detail: ccsqdInfo, // 出差申请单信息
          proType: route.proType, // 业务类型 机票 火车票
          currentRoute: route, // 当前行程信息
          routeId: route.routeId, //出行id
          ccsqdNo: ccsqdInfo.ccsqdNo, //出差单号
          ccsqdId: ccsqdInfo.id, //申请单ID ,
        };
        let chooseCcsqdObj = common.localget("chooseCcsqdObj") || {};
        chooseCcsqdObj[route.proType] = obj;
        common.localset("chooseCcsqdObj", chooseCcsqdObj);
      }
      // 设置出差申请单数据
      target.$store.commit("common/setCcsqdInfo", { ccsqdInfo });
      // 设置酒店出差申请单数据
      target.$store.commit("intHt/SET_HTCN_CCSQD", ccsqdInfo);
    }

    //房间人员信息
    let roomList = hotelOrderData.roomList;
    let rooms = [];
    let cxrListArr = [];
    for (let i = 0; i < roomList.length; i++) {
      let room = roomList[i];
      let cxrList = room.customerList;
      for (let c = 0; c < cxrList.length; c++) {
        var cxr = cxrList[c];
        cxr.deptId = cxr.empDeptid;
        cxr.empName = cxr.psgName;
        cxr.engName = cxr.psgNameEn;
        cxr.phoneNumber = cxr.psgPhone;
        cxr.costCenterCode = cxr.costCenterCode;
        cxr.costCenterId = cxr.costCenterId;
        cxr.costCenterName = cxr.costCenterName;
        cxrListArr.push(cxr);
      }
      rooms.push(cxrList);
    }
    minEmp = common.getMinEmpRank(cxrListArr);

    // 设置出行人 根据订单上人员
    target.$store.commit("intHt/SET_CXR_LIST", cxrListArr);
    target.$store.commit("intHt/SET_STATE", {
      rooms: rooms,
    });

    let hotelQuery = {
      tripType: hotelOrderData.tripType,
    };
    if (minEmp != void 0) {
      hotelQuery = Object.assign(hotelQuery, {
        empRank: minEmp.empRank || 0, //   职级
        useNameclbz: minEmp.cxrName || minEmp.empName, // 本次预订使用谁的差旅标准
        minEmpRankEmpId: minEmp.empId, // 当前员工差旅标准的职级
      });
    }

    //这是出差申请单模式的管控规则
    let params10999 = target.$common.getVipParamterByParNo(
      target.$store,
      10999,
      0
    );
    let params10995 = target.$common.getVipParamterByParNo(
      target.$store,
      10995,
      0
    );
    let params10996 = target.$common.getVipParamterByParNo(
      target.$store,
      10996,
      0
    );
    let params20002 = target.$common.getVipParamterByParNo(
      target.$store,
      20002,
      0
    );
    let params20003 = target.$common.getVipParamterByParNo(
      target.$store,
      20003,
      0
    );

    hotelQuery = Object.assign(hotelQuery, {
      gkfsRole: params10999, //0 不管控  1出差申请单管控  2差旅标准管控
      params10995, //  "成本中心是否必填"
      params10996, //   "项目是否必填"
      params20002, //   "订单填写页面是否显示成本中心，1显示，0不显示"
      params20003, //   "订单填写页面是否显示项目，1显示，0不显示"
    });
    target.$store.commit("intHt/SET_HTCN_QUERY", hotelQuery);

    // 跳转续住
    let hotelItem = {
      checkInDate: now,
      checkOutDate: next,
      jdid: hotelOrderData.jdid,
      cityId: hotelOrderData.cityId,
      delayOrdreType: 1, // 标识续住
    };
    target.$store.commit("intHt/SET_HTCN_PARAMS", {
      roomNum: rooms.length,
      adultNum: rooms[0].length,
      checkInDate: hotelItem.checkInDate,
      checkOutDate: hotelItem.checkOutDate,
      cityId: hotelItem.cityId,
      ccsqdCityName: hotelOrderData.cityName,
    });

    let routeUrl = target.$router.resolve({
      name: "interHotelDetail",
      query: hotelItem,
    });
    loading.close();
    window.open(routeUrl.href, "_blank");
  } catch (err) {
    let { tips } = err || {};
    tips &&
      target.$alert(tips, "", {
        type: "error",
      });
    loading.close();
  }
}

/**
 * @description 国际酒店因私根据房间数成人数初始化一个房间数组
 * @param {Number} roomsNum 最大房间数
 * @param {Number} adultNum 成人数
 */
export function handleIntYsRooms(roomsNum, adultNum, preRooms = []) {
  let rooms = [];

  // 如果有房间 先取出房间的人
  let cxrList = [];
  let array = common.deepCopy(preRooms);
  if (array && array.length > 0) {
    [...array].forEach((r) => {
      if (r && r.length > 0) {
        r.forEach((item) => {
          if (!isEmptyObject(item)) {
            cxrList.push({ ...item });
          }
        });
      }
    });
  }

  // 分配员工到房间
  for (let i = 0; i < roomsNum; i++) {
    let room = [];
    for (let j = 0; j < adultNum; j++) {
      let obj = cxrList.shift() || {};
      room.push(obj);
    }
    rooms.push(room);
  }
  return rooms;
}
